document.querySelectorAll('[data-drag-container]').forEach((container) => {
  const controller = container.querySelector('.drag-controller')
  if (controller) {
    const calculate = (e) => {
      if (e.target.closest('a')) {
        controller.classList.add('hidden')
        container.classList.remove('hide-cursor')
      } else {
        controller.classList.remove('hidden')
        container.classList.add('hide-cursor')
      }

      const offset = controller.getBoundingClientRect().width / 2
      controller.style.transform = `translate(${e.clientX - offset}px, ${
        e.clientY - offset
      }px)`
    }
    container.addEventListener('mousemove', calculate)
    container.addEventListener('mouseenter', function (e) {
      calculate(e)
      controller.classList.remove('hidden')
    })
    container.addEventListener('mouseleave', function () {
      controller.classList.add('hidden')
    })
  }
})
